"use client";

import { c as _c } from "react/compiler-runtime";
import dynamic from "next/dynamic";
import { assertUnreachable } from "@/helpers/AllowlistToolHelpers";
import DropListItemContentMediaAudio from "./DropListItemContentMediaAudio";
import { ImageScale } from "@/helpers/image.helpers";
import type { MediaLoadStrategy } from "./mediaLoadStrategy";
import DropListItemContentMediaImage from "./DropListItemContentMediaImage";
import DropListItemContentMediaVideo from "./DropListItemContentMediaVideo";
import MediaDisplay from "./MediaDisplay";
import UnsupportedMediaLink from "./UnsupportedMediaLink";
enum MediaType {
  IMAGE = "IMAGE",
  VIDEO = "VIDEO",
  AUDIO = "AUDIO",
  GLB = "GLB",
  HTML = "HTML",
  UNKNOWN = "UNKNOWN",
}
const DropListItemContentMediaGLB = dynamic(() => import("./DropListItemContentMediaGLB"), {
  ssr: false
});
export default function DropListItemContentMedia(t0) {
  const $ = _c(41);
  const {
    media_mime_type,
    media_url,
    isCompetitionDrop: t1,
    disableModal: t2,
    disableAutoPlay: t3,
    fillVideoContainer: t4,
    imageObjectPosition,
    imageScale: t5,
    htmlIframeContainerClassName,
    htmlPreviewImageUrl,
    loadStrategy: t6
  } = t0;
  const isCompetitionDrop = t1 === undefined ? false : t1;
  const disableModal = t2 === undefined ? false : t2;
  const disableAutoPlay = t3 === undefined ? false : t3;
  const fillVideoContainer = t4 === undefined ? false : t4;
  const imageScale = t5 === undefined ? ImageScale.AUTOx800 : t5;
  const loadStrategy = t6 === undefined ? "in-view" : t6;
  let t7;
  if ($[0] !== media_mime_type || $[1] !== media_url) {
    t7 = () => {
      if (media_mime_type.includes("image")) {
        return MediaType.IMAGE;
      }
      if (media_mime_type.includes("video")) {
        return MediaType.VIDEO;
      }
      if (media_mime_type.includes("audio")) {
        return MediaType.AUDIO;
      }
      if (media_mime_type === "model/gltf-binary" || media_mime_type === "model/gltf+json" || media_url.endsWith(".glb") || media_url.endsWith(".gltf")) {
        return MediaType.GLB;
      }
      if (media_mime_type === "text/html") {
        return MediaType.HTML;
      }
      return MediaType.UNKNOWN;
    };
    $[0] = media_mime_type;
    $[1] = media_url;
    $[2] = t7;
  } else {
    t7 = $[2];
  }
  const getMediaType = t7;
  let t8;
  if ($[3] !== disableAutoPlay || $[4] !== disableModal || $[5] !== fillVideoContainer || $[6] !== getMediaType || $[7] !== htmlIframeContainerClassName || $[8] !== htmlPreviewImageUrl || $[9] !== imageObjectPosition || $[10] !== imageScale || $[11] !== isCompetitionDrop || $[12] !== loadStrategy || $[13] !== media_mime_type || $[14] !== media_url) {
    t8 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const mediaType = getMediaType();
      switch (mediaType) {
        case MediaType.IMAGE:
          {
            let t9;
            if ($[16] !== disableModal || $[17] !== imageObjectPosition || $[18] !== imageScale || $[19] !== isCompetitionDrop || $[20] !== loadStrategy || $[21] !== media_url) {
              t9 = <DropListItemContentMediaImage src={media_url} isCompetitionDrop={isCompetitionDrop} disableModal={disableModal} imageObjectPosition={imageObjectPosition} imageScale={imageScale} loadStrategy={loadStrategy} />;
              $[16] = disableModal;
              $[17] = imageObjectPosition;
              $[18] = imageScale;
              $[19] = isCompetitionDrop;
              $[20] = loadStrategy;
              $[21] = media_url;
              $[22] = t9;
            } else {
              t9 = $[22];
            }
            t8 = t9;
            break bb0;
          }
        case MediaType.VIDEO:
          {
            let t9;
            if ($[23] !== disableAutoPlay || $[24] !== fillVideoContainer || $[25] !== media_url) {
              t9 = <DropListItemContentMediaVideo src={media_url} disableAutoPlay={disableAutoPlay} fillContainer={fillVideoContainer} />;
              $[23] = disableAutoPlay;
              $[24] = fillVideoContainer;
              $[25] = media_url;
              $[26] = t9;
            } else {
              t9 = $[26];
            }
            t8 = t9;
            break bb0;
          }
        case MediaType.AUDIO:
          {
            let t9;
            if ($[27] !== media_url) {
              t9 = <DropListItemContentMediaAudio src={media_url} />;
              $[27] = media_url;
              $[28] = t9;
            } else {
              t9 = $[28];
            }
            t8 = t9;
            break bb0;
          }
        case MediaType.GLB:
          {
            let t9;
            if ($[29] !== media_url) {
              t9 = <DropListItemContentMediaGLB src={media_url} />;
              $[29] = media_url;
              $[30] = t9;
            } else {
              t9 = $[30];
            }
            t8 = t9;
            break bb0;
          }
        case MediaType.HTML:
          {
            let t9;
            if ($[31] !== disableAutoPlay || $[32] !== htmlIframeContainerClassName || $[33] !== htmlPreviewImageUrl || $[34] !== imageScale || $[35] !== loadStrategy || $[36] !== media_mime_type || $[37] !== media_url) {
              t9 = <MediaDisplay media_mime_type={media_mime_type} media_url={media_url} imageScale={imageScale} previewImageUrl={htmlPreviewImageUrl} requireInteractionToLoad={disableAutoPlay} iframeContainerClassName={htmlIframeContainerClassName} loadStrategy={loadStrategy} />;
              $[31] = disableAutoPlay;
              $[32] = htmlIframeContainerClassName;
              $[33] = htmlPreviewImageUrl;
              $[34] = imageScale;
              $[35] = loadStrategy;
              $[36] = media_mime_type;
              $[37] = media_url;
              $[38] = t9;
            } else {
              t9 = $[38];
            }
            t8 = t9;
            break bb0;
          }
        case MediaType.UNKNOWN:
          {
            let t9;
            if ($[39] !== media_url) {
              t9 = <UnsupportedMediaLink media_url={media_url} />;
              $[39] = media_url;
              $[40] = t9;
            } else {
              t9 = $[40];
            }
            t8 = t9;
            break bb0;
          }
        default:
          {
            t8 = assertUnreachable(mediaType);
            break bb0;
          }
      }
    }
    $[3] = disableAutoPlay;
    $[4] = disableModal;
    $[5] = fillVideoContainer;
    $[6] = getMediaType;
    $[7] = htmlIframeContainerClassName;
    $[8] = htmlPreviewImageUrl;
    $[9] = imageObjectPosition;
    $[10] = imageScale;
    $[11] = isCompetitionDrop;
    $[12] = loadStrategy;
    $[13] = media_mime_type;
    $[14] = media_url;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  if (t8 !== Symbol.for("react.early_return_sentinel")) {
    return t8;
  }
}